import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bundle } from '@kineticdata/react';
import { selectServicesKapp, Utils, C } from '@kineticdata/bundle-common';
import { FavoritesDropdown } from './FavoritesDropdown';

const MobileNavComponent = props => (
  <>
    {!!props.servicesKapp && (
      <>
        {props.hasCallLogAccess && (
          <button
            className="nav-link"
            title="Call Log"
            onClick={() => {
              window.open(
                `${bundle.spaceLocation()}/#/kapps/${
                  props.servicesKapp.slug
                }/frameless/forms/${C.FORM_SLUG_CALL_LOG}`,
                '',
                'width=600, height=1000',
              );
            }}
          >
            <i className="fa fa-fw fa-lg fa-phone" />
          </button>
        )}
        {props.profile.hasAgreements && (
          <Link
            className="nav-link"
            to={`/kapps/${props.servicesKapp.slug}/forms/${
              C.FORM_SLUG_ESCALATE
            }`}
            title="Escalate"
          >
            <i className="fa fa-fw fa-lg fa-exclamation-circle" />
          </Link>
        )}
      </>
    )}
    {props.monitoringUrl && (
      <a
        href={props.monitoringUrl}
        title="Systems Monitoring Dashboard"
        className="nav-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fa fa-fw fa-lg fa-tachometer-alt" />
      </a>
    )}
    {props.slaPortalLink && (
      <Link
        className="nav-link"
        to={`/kapps/${props.slaPortalLink.kapp.slug}/page/${
          props.slaPortalLink.slug
        }`}
        title={props.slaPortalLink.name}
      >
        <i className="fa fa-fw fa-lg fa-chart-bar" />
      </Link>
    )}
    <a
      href="https://cxodashboard.dl.usda.gov/#/projects/1184"
      title="Customer Dashboards"
      className="nav-link"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i className="fa fa-fw fa-lg fa-chart-line" />
    </a>
    {props.emsCustomerPortalUrl && (
      <a
        href={props.emsCustomerPortalUrl}
        title="OCIO EMS Customer Portal"
        className="nav-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fa fa-fw fa-lg fa-briefcase" />
      </a>
    )}
    {props.itsmWebUrl && (
      <a
        href={props.itsmWebUrl}
        title="ITSM System"
        className="nav-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fa fa-fw fa-lg fa-ticket-alt" />
      </a>
    )}
    <FavoritesDropdown />
  </>
);

export const MobileNav = connect(state => {
  const servicesKapp = selectServicesKapp(state);
  const itsmWebUrlCompanies = Utils.getAttributeValues(
    state.app.space,
    C.SPACE_ATTR_ITSM_WEB_URL_COMPANIES,
  );
  const userCompany = Utils.getAttributeValue(
    state.app.profile,
    C.ATTRIBUTE_USER_COMPANY,
  );
  return {
    appLocation: state.app.location,
    servicesKapp,
    profile: state.app.profile,
    hasCallLogAccess:
      servicesKapp &&
      servicesKapp.forms.find(({ slug }) => slug === C.FORM_SLUG_CALL_LOG),
    slaPortalLink: state.app.portalPages.find(
      p => p.slug === C.FORM_SLUG_SLA_PORTAL,
    ),
    itsmWebUrl:
      userCompany && itsmWebUrlCompanies.includes(userCompany)
        ? Utils.getAttributeValue(state.app.space, C.SPACE_ATTR_ITSM_WEB_URL)
        : null,
    monitoringUrl: Utils.getAttributeValue(
      state.app.space,
      C.SPACE_ATTR_MONITORING_URL,
    ),
    emsCustomerPortalUrl: Utils.getAttributeValue(
      state.app.space,
      C.SPACE_ATTR_EMS_CUSTOMER_PORTAL_URL,
    ),
  };
})(MobileNavComponent);
